import { Injectable } from '@angular/core';
import { Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';
import { SxHttpService } from './sxHttp.service';
import { TemplateListadoItem } from '../model/classes/templateListadoItem.class';
import { CategoriaProducto } from '../model/interfaces/categoriaProducto.interface';

@Injectable()
export class CategoriaProductosService {
  private url = 'api/categoriaProducto';

  constructor(private sxHttp: SxHttpService) { }

  crear(categoria: CategoriaProducto): Promise<CategoriaProducto> {
    return this.sxHttp.post(this.url, categoria)
      .toPromise()
      .then(res => res.json().data as CategoriaProducto);
  }

  getCategoriaById(systemCode, categoryCode): Observable<CategoriaProducto> {
    return this.sxHttp.get(this.url + '/' + systemCode + '/' + categoryCode).map(response => {
      return response.json().data as CategoriaProducto;
    });
  }

  getForTemplateListado(systemCode?: string): Observable<TemplateListadoItem[]> {
    let url = this.url;

    if (systemCode != null) {
      url += '/' + systemCode;
    }

    return this.sxHttp.get(url).map(response => {
      const categorias = response.json().data;
      return categorias.map(categoria => {
        return {
          id: categoria.codCategoria,
          imagen: categoria.urlImage,
          titulo: categoria.descCategoria,
          subtitulo: categoria.codCategoria,
          resumen: categoria.secciones.map(seccion => '(' + seccion.codSeccion + ') - ' + seccion.descripcion),
        };
      });
    });
  }

  getForSelect(): Observable<any[]> {
    return this.sxHttp.get(this.url).map(response => {
      const categorias = response.json().data;
      return categorias.map(categoria => {
        return {
          codigo: categoria.codCategoria,
          descripcion: categoria.descCategoria,
        };
      });
    });
  }

  editarCategoria(categoria: CategoriaProducto): Promise<CategoriaProducto> {
    return this.sxHttp.post(this.url, categoria)
      .toPromise()
      .then(res => res.json().data as CategoriaProducto);
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/categoria-productos.service.ts